<template>
  <div>
    <div class="row topCardGrid">
      <sp-card :valor="cardsData.total" :descricao="cardsData.descTotal"
        :footerText="$t('rodape.estimativa', {fonte: cards.metadados.fonte, data: cards.metadados.data})" :lgGrid="3"></sp-card>
      <sp-card :valor="cardsData.valorPrimeira" :valorProgressBar="cardsData.valorPorcPrimeira"
        :footerText="$t('rodape.estimativa', {fonte: cards.metadados.fonte, data: cards.metadados.data})"
        :descricao="cardsData.descPrimeira" :lgGrid="3"></sp-card>
      <sp-card :valor="cardsData.valorRetorno" :valorProgressBar="cardsData.valorPorcRetorno"
        :footerText="$t('rodape.estimativa', {fonte: cards.metadados.fonte, data: cards.metadados.data})"
        :descricao="cardsData.descRetorno" :lgGrid="3"></sp-card>
      <sp-card :valor="cardsData.valorExame" :valorProgressBar="cardsData.valorPorcExame"
        :footerText="$t('rodape.estimativa', {fonte: cards.metadados.fonte, data: cards.metadados.data})"
        :descricao="cardsData.descExame" :lgGrid="3"></sp-card>

    </div>
    <div class="row">
      <div class="flex md12 xs12">
        <sp-360-panel class="chart-widget" :title="$t('graficosSaude.filaHistoricoUltimosMeses')"
          :tooltipOptions="tooltipLineHistoricoUltimosMeses" :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})" >

          <sp360-chart v-bind:data="dataLineHistoricoUltimosMeses" :options="optionsLineHistoricoUltimosMeses"
            type="line" />

        </sp-360-panel>
      </div>
    </div>
    <div class="row">
      <div class="flex md12 xs12">
        <sp-360-panel class="chart-widget" :title="$t('graficosSaude.filaPrimeiraConsultaEspecialidade')"
          :tooltipOptions="tooltipBarEspecialidadePrimeira" :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})" >

          <sp360-chart v-bind:data="dataBarEspecialidadeConsulta" :options="optionsBarEspecialidadeConsulta"
            type="horizontal-bar" />

        </sp-360-panel>
      </div>
    </div>

    <div class="row">
      <div class="flex md12 xs12">
        <sp-360-panel class="chart-widget" :title="$t('graficosSaude.filaConsultaRetornoEspecialidade')"
          :tooltipOptions="tooltipBarEspecialidadeRetorno" :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})" >

          <sp360-chart v-bind:data="dataBarEspecialidadeRetorno" :options="optionsBarEspecialidadeRetorno"
            type="horizontal-bar" />

        </sp-360-panel>
      </div>
    </div>
    <div class="row">
      <div class="flex md12 xs12">
        <sp-360-panel class="chart-widget" :title="$t('graficosSaude.filaExameSubgrupo')"
          :tooltipOptions="tooltipBarExameSubgrupo" :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})"  >

          <sp360-chart v-bind:data="dataBarExameSubgrupo" :options="optionsBarExameSubgrupo" type="horizontal-bar" />

        </sp-360-panel>
      </div>
    </div>
    <!-- <div class="row">
      <div class="flex md12 xs12">
        <sp-360-panel class="chart-widget" :title="$t('graficosSaude.filaExameAlias')"
          :tooltipOptions="tooltipBarExameAlias" :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})"  >

          <sp360-chart v-bind:data="dataBarExameAlias" :options="optionsBarExameAlias" type="horizontal-bar" />

        </sp-360-panel>
      </div>
    </div>
    <div class="row">
      <div class="flex md12 xs12">
        <sp-360-panel class="chart-widget" :title="$t('graficosSaude.filaExameProcedimento')"
          :tooltipOptions="tooltipBarExameProcedimento" :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})" >

          <sp360-chart v-bind:data="dataBarExameProcedimento" :options="optionsBarExameProcedimento"
            type="horizontal-bar" />

        </sp-360-panel>

      </div>
    </div> -->
  </div>
</template>

<script>
import _ from 'lodash'
import MetodosGlobais from '@/utils/MetodosGlobais'
import Constantes from '@/utils/ConstantesGlobais'
import CorUtil from '@/utils/CorUtils'
import SpCard from '@/components/ui/cards/SP360Card'
import Sp360Chart from '@/components/ui/chart/sp360chart'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'

export default {
  name: 'fila-atendimento-exame',
  components: {
    SpCard,
    Sp360Chart,
    Sp360Panel,
  },
  data () {
    return {
      cardsData: {},
      cards: {
        metadados: {
          fonte: '',
          data: '',
        },
      },
      cores: _.shuffle(CorUtil.getVetorCoresPorTom('claro')),
      optionsBarExameSubgrupo: {},
      dataBarExameSubgrupo: {},
      optionsBarExameProcedimento: {},
      dataBarExameProcedimento: {},
      tooltipBarConsulta: {
        content: this.$t('graficosSaude.tooltipFilaConsulta'),
        placement: 'bottom',
      },
      tooltipBarExameProcedimento: {
        content: this.$t('graficosSaude.tooltipFilaExameProcedimento'),
        placement: 'bottom',
      },
      tooltipBarExameSubgrupo: {
        content: this.$t('graficosSaude.tooltipFilaExameSubgrupo'),
        placement: 'bottom',
      },
      tooltipBarExameAlias: {
        content: this.$t('graficosSaude.tooltipFilaExameAlias'),
        placement: 'bottom',
      },
      optionsBarEspecialidadeConsulta: {},
      dataBarEspecialidadeConsulta: {},
      optionsBarEspecialidadeRetorno: {},
      dataBarEspecialidadeRetorno: {},
      tooltipBarEspecialidadePrimeira: {
        content: this.$t('graficosSaude.tooltipFilaEspecialidadePrimeira'),
        placement: 'bottom',
      },
      tooltipBarEspecialidadeRetorno: {
        content: this.$t('graficosSaude.tooltipFilaEspecialidadeRetorno'),
        placement: 'bottom',
      },
      dataBarExameAlias: {},
      optionsBarExameAlias: {},
      dataLineHistoricoUltimosMeses: {},
      optionsLineHistoricoUltimosMeses: {},
      tooltipLineHistoricoUltimosMeses: {
        content: this.$t('graficosSaude.tooltipHistoricoUltimosMeses'),
        placement: 'bottom',
      },
    }
  },
  computed: {

  },
  created () {
    Promise.all([
      this.$store.dispatch('saude/buscarFilaConsolidado'),
      this.$store.dispatch('saude/buscarFilaDeExamePorSubgrupo', { tipoProcedimento: 'DIAGNOSTICO' }),
      // this.$store.dispatch('saude/buscarFilaDeExamePorSubgrupo', { tipoProcedimento: 'DIAGNOSTICO', agrupamento: 'ALIAS' }), //2
      // this.$store.dispatch('saude/buscarFilaPorProcedimento', { tipoProcedimento: 'DIAGNOSTICO', categoria: 'outros' }),    //3
      this.$store.dispatch('saude/buscarFilaDeConsultaPorEspecialidade', { tipoConsulta: 'PRIMEIRA' }),
      this.$store.dispatch('saude/buscarFilaDeConsultaPorEspecialidade', { tipoConsulta: 'RETORNO' }),
      this.$store.dispatch('saude/buscarFilaDeExameHistoricoUltimosMeses', { ultimosMeses: 13 }),
    ])
      .then(
        (respostas) => {
          // {fonte: fonte, data: dataRef}
          // :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})"
          this.fonte = respostas[0].data.sigla_orgao + '-' + respostas[0].data.fonte
          this.dataRef = MetodosGlobais.formataDataParaStringDataLocal(new Date(respostas[0].data.data_referencia_dado))
          this.ref = this.$t('rodape.fonteData', { fonte: this.fonte, data: this.dataRef })

          this.cardsData = this.populateCards(respostas[0].data)
          let barExameSubgrupo = this.populateBarSubgrupo(respostas[1].data.data, 'graficosSaude.barFilaEixoX', 'graficosSaude.barSubGrupoEixoY')
          this.dataBarExameSubgrupo = barExameSubgrupo.chartData
          this.optionsBarExameSubgrupo = barExameSubgrupo.options

          // let barExameAlias = this.populateBarSubgrupo(respostas[2].data.data, 'graficosSaude.barFilaEixoX', 'graficosSaude.barAliasEixoY')
          // this.dataBarExameAlias = barExameAlias.chartData
          // this.optionsBarExameAlias = barExameAlias.options

          // let barExameProcedimento = this.populateBarProcedimento(respostas[3].data.data, 'graficosSaude.barFilaEixoX', 'graficosSaude.barProcedimentoEixoY')
          // this.dataBarExameProcedimento = barExameProcedimento.chartData
          // this.optionsBarExameProcedimento = barExameProcedimento.options

          let barEspecialidadeConsulta = this.populateBarEspecialidade(respostas[2].data.data, 'graficosSaude.barFilaEixoX', 'graficosSaude.barEspecialidadeEixoY')
          this.dataBarEspecialidadeConsulta = barEspecialidadeConsulta.chartData
          this.optionsBarEspecialidadeConsulta = barEspecialidadeConsulta.options

          let barEspecialidadeRetorno = this.populateBarEspecialidade(respostas[3].data.data, 'graficosSaude.barFilaEixoX', 'graficosSaude.barEspecialidadeEixoY')
          this.dataBarEspecialidadeRetorno = barEspecialidadeRetorno.chartData
          this.optionsBarEspecialidadeRetorno = barEspecialidadeRetorno.options

          let lineHistoricoUltimosMeses = this.populateLineHistorico(respostas[4].data.data, 'graficosSaude.lineFilaHistoricoEixoX', 'graficosSaude.lineFilaHistoricoEixoY')
          this.dataLineHistoricoUltimosMeses = lineHistoricoUltimosMeses.chartData
          this.optionsLineHistoricoUltimosMeses = lineHistoricoUltimosMeses.options
        }
      )
      .catch(
        (error) => {
          console.error(error)
        })
  },
  methods: {
    rodapeData (d, data) {
      return MetodosGlobais.rodapeData(d, data)
    },
    populateCards (dados) {
      this.cards.metadados.fonte = dados.sigla_orgao
      this.cards.metadados.data = MetodosGlobais.dataParaMesExtensoAno(MetodosGlobais.formataDataParaStringDataLocal(new Date(dados.data_referencia_dado)))
      dados = dados.data
      let data = {}
      data.valorExame = dados[0].total
      // data.desc1 = dados[0].tipo_procedimento;
      data.valorRetorno = dados[1].total
      // data.desc2 = dados[1].tipo_procedimento;
      data.valorPrimeira = dados[2].total
      // data.desc3 = dados[2].tipo_procedimento;
      // data.valor4 = dados[3].total;
      // data.desc4 = dados[3].tipo_procedimento;
      data.total = _.reduce(dados, (i, n) => {
        return i + n.total
      }, 0)
      data.descTotal = this.$t('graficosSaude.descCardTotal')
      data.descPrimeira = this.$t('graficosSaude.descCardPrimeira')
      data.descRetorno = this.$t('graficosSaude.descCardRetorno')
      data.descExame = this.$t('graficosSaude.descCardExame')
      // Essa divisão/multiplicação por 1e2 foi o método que encontrei para arredondar para 2 casas decimais sem usar o toFixed
      // Para mudar o número de casas decimais é só trocar o 2 por outro número
      let dadosCards = [(dados[0].total / data.total * 100), (dados[1].total / data.total * 100), (dados[2].total / data.total * 100)]
      let percCorrigido = MetodosGlobais.arredondaPorcentagens(dadosCards, 0)
      data.valorPorcExame = percCorrigido[0]
      data.valorPorcRetorno = percCorrigido[1]
      data.valorPorcPrimeira = percCorrigido[2]
      return data
    },

    populateBarSubgrupo (d, legendaX, legendaY) {
      let chartData = {}
      let options = {}
      let datasets = []
      let cores = this.cores
      let Labels = ''

      Labels = _.map(d, (r) => {
        return r.nome
      })

      let total = _.map(d, (n) => {
        return n.total
      })

      let corDataset = cores.shift()
      let dataset = {
        label: this.$t('graficosSaude.porProcedimento'),
        backgroundColor: corDataset,
        data: total,
      }
      datasets.push(dataset)

      chartData = {
        datasets: datasets,
        labels: Labels,
      }

      options = this.getOptions(legendaX, legendaY)

      return {
        chartData,
        options,
      }
    },

    populateBarProcedimento (d, legendaX, legendaY) {
      let chartData = {}
      let options = {}
      let datasets = []
      let cores = this.cores
      let Labels = ''

      Labels = _.map(d, (r) => {
        return r.procedimento
      })

      let total = _.map(d, (n) => {
        return n.total
      })

      let corDataset = cores.shift()
      let dataset = {
        label: this.$t('graficosSaude.porProcedimento'),
        backgroundColor: corDataset,
        data: total,
      }
      datasets.push(dataset)

      chartData = {
        datasets: datasets,
        labels: Labels,
      }

      options = this.getOptions(legendaX, legendaY)

      return {
        chartData,
        options,
      }
    },

    populateBarEspecialidade (d, legendaX, legendaY) {
      let chartData = {}
      let options = {}
      let datasets = []
      let cores = this.cores
      let Labels = ''

      Labels = _.map(d, (r) => {
        return r.especialidade
      })

      let total = _.map(d, (n) => {
        return n.total
      })

      let corDataset = cores.shift()
      let dataset = {
        label: this.$t('graficosSaude.porProcedimento'),
        backgroundColor: corDataset,
        data: total,
      }
      datasets.push(dataset)

      chartData = {
        datasets: datasets,
        labels: Labels,
      }

      options = this.getOptions(legendaX, legendaY)

      return {
        chartData,
        options,
      }
    },

    processaHistoricoTotal (d) {
      let agrupadoPorData = _.groupBy(d, (i) => {
        return i.mes + '/' + i.ano
      })

      let HistoricoTotal = _.map(agrupadoPorData, i => {
        return {
          ano: i[0].ano,
          mes: i[0].mes,
          total: _.sumBy(i, 'total'),
        }
      })

      return HistoricoTotal
    },

    populateLineHistorico (d, legendaX, legendaY) {
      let chartData = {}
      let options = {}
      let datasets = []
      let cores = this.cores
      let Labels = ''
      let dados = _.groupBy(d, 'tipo_procedimento')

      let totalLabel = this.$t('graficosSaude.labelHistoricoTotal') // 'Total de Procedimentos'

      dados[totalLabel] = this.processaHistoricoTotal(d)

      _.forEach(Object.keys(dados), key => {
        Labels = _.map(dados[key], (r) => {
          return MetodosGlobais.mapeiaMesAbreviacao(parseInt(r.mes)).abrev + '/' + r.ano
        })

        let fila = _.map(dados[key], (n) => {
          return n.total
        })

        let corDataset = cores.shift()
        let datasetHistorico = {
          label: this.getLabelGraficoHistorico(key),
          fill: false,
          backgroundColor: corDataset,
          borderColor: corDataset,
          data: fila,
          yAxisID: 'y-axis-1',
        }

        datasets.push(datasetHistorico)
      })

      chartData = {
        datasets: datasets,
        labels: Labels,
      }

      options = this.getOptionsLine(legendaX, legendaY, false, true)

      return {
        chartData,
        options,
      }
    },

    getLabelGraficoHistorico (key) {
      if (key == 'Procedimentos clínicos (retorno)') return this.$t('graficosSaude.labelHistoricoRetorno')// "Consultas de retorno"
      if (key == 'Procedimentos clínicos') return this.$t('graficosSaude.labelHistoricoPrimeira') // "Primeira consulta"
      if (key == 'Procedimentos com finalidade diagnóstica') return this.$t('graficosSaude.labelHistoricoExame') // "Exames"
      return key
    },

    getOptions (legendaX, legendaY, percentual = true, milhar = false) {
      return {
        layout: {
          padding: {
            left: 0,
            right: 50,
            top: 0,
            bottom: 0,
          },
        },
        plugins: {
          datalabels: {
            color: CorUtil.getCorPorNomeSp360('preto-escuro'),
            formatter: (value) => MetodosGlobais.thousandSeparator(value),
            anchor: 'end',
            clamp: true,
            align: 'end',
            color: '#000',
            display: 'auto',
            labels: {
              value: {
                font: {
                  weight: 'bold',
                },
              },
            },
          },
        },
        tooltips: {
          callbacks: MetodosGlobais.percentualLabelCallback(false, true, 'horizontal-bar'),
        },
        legend: {
          display: false,
        },
        scales: {
          xAxes: [{
            ticks: {
              autoSkip: false,
              maxRotation: 30,
              callback: (value) => MetodosGlobais.thousandSeparator(value),
            },
            display: true,
            scaleLabel: {
              display: true,
              labelString: this.$t(legendaX),
            },
          }],
          yAxes: [{
            display: true,
            scaleLabel: {
              display: true,
              labelString: this.$t(legendaY),
            },
          }],
        },
      }
    },

    tooltipsCallback (perc, separadorMilhar) {
      return {
        label: function (tooltipItem, data) {
          var label = ''
          if (separadorMilhar) { label += MetodosGlobais.thousandSeparator(tooltipItem.yLabel) } else { label += tooltipItem.yLabel }
          if (label && perc) {
            label += '%'
          }
          return label
        },
      }
    },

    getOptionsLine (legendaX, legendaY, percentual = true, milhar = false) {
      return {
        // maintainAspectRatio: false,
        // aspectRatio: '16:9',

        tooltips: {
          mode: 'x',
          intersect: true,
          callbacks: this.tooltipsCallback(percentual, milhar),
        },
        scales: {
          xAxes: [{
            display: true,
            scaleLabel: {
              display: true,
              labelString: this.$t(legendaX || 'LegendaX'),
            },
          }],
          yAxes: [{
            ticks: {
              callback: (value) => MetodosGlobais.thousandSeparator(value),
              beginAtZero: true,
            },
            id: 'y-axis-1',
            type: 'linear',
            position: 'left',
            display: true,
            scaleLabel: {
              display: true,
              labelString: this.$t(legendaY || 'LegendaY'),
            },
          }],
        },
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.va-chart {
  max-height: 25rem
}
</style>
